// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD4L24cTvEP2BPP75RpGp4krbpi9VgU_b8",
  authDomain: "natdisaster-datasets.firebaseapp.com",
  projectId: "natdisaster-datasets",
  storageBucket: "natdisaster-datasets.appspot.com",
  messagingSenderId: "296616389779",
  appId: "1:296616389779:web:2333e557734bcbc5963166",
  measurementId: "G-80PYZWF3RB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app)
export const analytics = getAnalytics(app);
export const auth = getAuth();

